import React from "react";

// Detects the "stale build" failure: after a redeploy the browser may still hold
// an old index.html that points at JS chunk hashes which no longer exist, so a
// lazy import() rejects. React surfaces this as an uncaught error → white screen.
const isChunkError = (error) => {
  const msg = `${error?.name || ""} ${error?.message || ""}`;
  return /ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module|module script failed|Failed to fetch/i.test(msg);
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunk: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, isChunk: isChunkError(error) };
  }

  componentDidCatch(error) {
    if (isChunkError(error)) {
      // Reload ONCE (guarded) to fetch the fresh build instead of showing white.
      const KEY = "sagt_chunk_reload_ts";
      const last = Number(sessionStorage.getItem(KEY) || 0);
      if (Date.now() - last > 10000) {
        sessionStorage.setItem(KEY, String(Date.now()));
        window.location.reload();
      }
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const wrap = {
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "#050505", fontFamily: "system-ui, sans-serif", padding: 24,
    };

    if (this.state.isChunk) {
      return (
        <div style={wrap} data-testid="chunk-reload-screen">
          <div style={{ textAlign: "center", color: "#FFB81C" }}>
            <div style={{
              width: 34, height: 34, border: "3px solid #FFB81C", borderTopColor: "transparent",
              borderRadius: "50%", margin: "0 auto 16px", animation: "sagt-spin 0.8s linear infinite",
            }} />
            <p style={{ fontSize: 13, letterSpacing: 1, textTransform: "uppercase" }}>Updating to the latest version…</p>
          </div>
          <style>{"@keyframes sagt-spin{to{transform:rotate(360deg)}}"}</style>
        </div>
      );
    }

    return (
      <div style={wrap} data-testid="app-error-screen">
        <div style={{ textAlign: "center", maxWidth: 420, color: "#fff" }}>
          <h1 style={{ color: "#FFB81C", fontSize: 20, marginBottom: 12, textTransform: "uppercase", letterSpacing: 2 }}>Something went wrong</h1>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 14, marginBottom: 24 }}>
            The page hit an unexpected error. Reloading usually fixes it.
          </p>
          <button
            onClick={() => window.location.reload()}
            data-testid="error-reload-btn"
            style={{ background: "#FFB81C", color: "#000", border: "none", padding: "10px 26px", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, cursor: "pointer" }}
          >
            Reload Page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
